// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1m-0";
export var spinnerContainer = "_1m-1";